import Usuario from "../../components/usuario_comp";
import UsuarioContextProvider from "../../contexts/usuario-context";

const ViewUsuarios = () => {
    return (
            <UsuarioContextProvider>
                <Usuario />
            </UsuarioContextProvider>
    )
}

export default ViewUsuarios;